import {
  ConnectionListResult,
  FeatureFlagsContext,
  GridSortProps,
  MaxCountsResultData,
  PaginatedQueryWrapper,
  SelectionProviderChildProps,
} from '@tableau/data-catalog-shared';
import * as React from 'react';

import {
  VirtualConnectionTablesByIdQuery,
  VirtualConnectionTablesByIdQuery_virtualConnections_tablesConnection_nodes,
  VirtualConnectionTablesByIdQueryVariables,
} from '../../../gen-src/queries/VirtualConnectionTablesByIdQuery';
import { VirtualConnectionTableSortOrder } from '../../../gen-src/queries/globalTypes';
import { VirtualConnectionTablesByIdQueryGql } from '../../queries/VirtualConnectionTablesByIdQueryGql';
import { FieldsValidSortFields } from '../sorting/sortProviders/FieldsGridSortProvider';
import { getRowDataWithMaxCountsForVirtualConnectionTable } from '../table/functions/VirtualConnectionTableRowDataFunctions';
import { VirtualConnectionTablesDisplayGridRowData } from "../table/types/VirtualConnectionTablesDisplayGridRowData";
import {
  VirtualConnectionTablesDisplayGrid,
} from './VirtualConnectionTablesDisplayGrid';

export type QueryVariables = VirtualConnectionTablesByIdQueryVariables;
export type QueryResults = VirtualConnectionTablesByIdQuery;
export type QueryResultListNode = VirtualConnectionTablesByIdQuery_virtualConnections_tablesConnection_nodes;
export type GridRowData = VirtualConnectionTablesDisplayGridRowData;

export type VirtualConnectionTablesQueryGridProps =
  SelectionProviderChildProps &
  GridSortProps<FieldsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.virtualConnections && resultData.virtualConnections[0] &&
    resultData.virtualConnections[0].tablesConnection;
}

function selectMaxCountsResult(resultData: QueryResults): MaxCountsResultData {
  return resultData && resultData.virtualConnections && resultData.virtualConnections[0];
}

function getRowDataForVirtualConnectionTable(
  node: QueryResultListNode,
  resultData: QueryResults,
): GridRowData {
  return getRowDataWithMaxCountsForVirtualConnectionTable(node, selectMaxCountsResult(resultData));
}

export function VirtualConnectionTablesQueryGrid(props: VirtualConnectionTablesQueryGridProps): JSX.Element {
  const { publishedConnectionsLineageEnabled } = React.useContext(FeatureFlagsContext);
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTablesByIdQueryGql}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as unknown as VirtualConnectionTableSortOrder,
        publishedConnectionsLineageEnabled
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForVirtualConnectionTable}
    >
      {({ rowStore }) => (
        <VirtualConnectionTablesDisplayGrid
          rowStore={rowStore}
          selectedKeys={props.selectedKeys}
          updateSelectionForKey={props.updateSelectionForKey}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
